import { Playground } from '../../../components/playground/Playground';
import { Headline } from '../../../components/Headline';
import { Title } from '../../../components/Title';

import { icons, getIconNames } from '../../../utils/icons';

const vehicleIcons = [...getIconNames(icons.vehicles)] as string[];

export const IconVehicle = () => (
    <div className='uikit-icons'>
        <Headline headlineType='h3' anchor='vehicleIcons'>
            Vehicle icons
        </Headline>
        <Playground example={iconVehicleIconsExample} />
    </div>
);

const iconVehicleIconsExample = (
    <div className='display-flex flex-wrap gap-50'>
        <div>
            <Title>Vehicle icons</Title>
            <div className='display-flex flex-wrap gap-10 border border-bottom-only'>
                {vehicleIcons.map(icon => (
                    <span className={`uikit-icon ${icon} text-size-h1`} key={icon} />
                ))}
            </div>
        </div>
        <div>
            <Title>Baseline vehicle icons</Title>
            <div className='display-flex flex-wrap gap-10 border border-bottom-only'>
                {vehicleIcons.map(icon => (
                    <span className={`uikit-icon ${icon}-baseline text-size-h1`} key={icon} />
                ))}
            </div>
        </div>
    </div>
);
